module.exports = __webpack_public_path__ + "img/ziliao.aece74b2.png";